import "core-js/modules/es.array.map";

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:
*/
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Block from 'wfui-digital-core/es/Block';
import withBrand from 'wfui-digital-core/es/withBrand';
import { getClasses } from 'wfui-digital-core/es/lib';
import MastheadMessageCenterButton from './masthead-message-center-button/MastheadMessageCenterButton';
import MastheadSearchButton from './masthead-search-button/MastheadSearchButton';
import MastheadSignoffButton from './masthead-signoff-button/MastheadSignoffButton';
import MastheadAvatarButton from './masthead-avatar-button/MastheadAvatarButton';
import { requestNavigation } from '../../../../../lib/store/navigation/actions';
import { openGlobalSearch as _openGlobalSearch } from '../../../../../lib/store/global-search/actions';
import styles from './MastheadButtons.less';

var MastheadButton = function MastheadButton(_ref) {
  var linkId = _ref.linkId,
      linkName = _ref.linkName,
      attributes = _ref.attributes,
      handleNavigation = _ref.handleNavigation,
      openGlobalSearch = _ref.openGlobalSearch;

  switch (linkId) {
    case 'ENTERPRISE_SEARCH':
      {
        return /*#__PURE__*/React.createElement(MastheadSearchButton, {
          mastHeadButton: true,
          searchAction: openGlobalSearch
        });
      }

    case 'UNREAD_MESSAGE':
      return /*#__PURE__*/React.createElement(MastheadMessageCenterButton, {
        messageCount: linkName,
        handleClick: function handleClick() {
          handleNavigation(attributes);
        }
      });

    case 'SIGN_OFF':
      return /*#__PURE__*/React.createElement(MastheadSignoffButton, {
        bevName: attributes.bevName,
        label: attributes.linkName
      });

    case 'WELCOME_MESSAGE':
      return /*#__PURE__*/React.createElement(MastheadAvatarButton, {
        welcomeText: attributes.linkName,
        attributes: attributes
      });

    default:
      return null;
  }
};

var MastheadButtons = function MastheadButtons(_ref2) {
  var handleNavigation = _ref2.handleNavigation,
      navigationItems = _ref2.navigationItems,
      navigationDisabled = _ref2.navigationDisabled,
      brand = _ref2.brand,
      openGlobalSearch = _ref2.openGlobalSearch;
  var profileBarItems = navigationItems.get('profileBarItems');
  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    el: "ul",
    className: getClasses({
      styles: styles,
      brand: brand,
      classes: ['mastheadButtons']
    })
  }, !navigationDisabled && profileBarItems && profileBarItems.map(function (button) {
    return /*#__PURE__*/React.createElement(MastheadButton, {
      key: button.linkId,
      linkId: button.linkId,
      linkName: button.linkName,
      attributes: button,
      handleNavigation: handleNavigation,
      openGlobalSearch: openGlobalSearch
    });
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    navigationItems: state.core.navigationMenu.mastheadNavigationItems,
    navigationDisabled: state.core.navigation.navigationDisabled
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleNavigation: function handleNavigation(navigationItem) {
      return dispatch(requestNavigation(navigationItem.toJS()));
    },
    openGlobalSearch: function openGlobalSearch() {
      return dispatch(_openGlobalSearch());
    }
  };
};

export default compose(withBrand, connect(mapStateToProps, mapDispatchToProps))(MastheadButtons);